import React from 'react';
import { useBuildVars } from '../../../config';
import { ErrorContentLocalizedX4C } from './ErrorContentLocalizedX4C';
import { ErrorContentLocalizedX4EC } from './ErrorContentLocalizedX4EC';
import { ErrorContentWithThemeX4EC } from './ErrorContentWithThemeX4EC';
// import { ErrorContentWithThemeX4C } from './ErrorContentWithThemeX4C';

export const ErrorContent = ({
  // Default to true for backward compatibility with X4C ErrorContent
  variant,
}: {
  variant: 'localized' | 'theme-and-localized';
}) => {
  document.getElementById('loaderDiv')?.remove();

  const { appId } = useBuildVars();

  if (variant === 'localized') {
    if (appId === 'cep') return <ErrorContentLocalizedX4C />;
    if (appId === 'x4ec') return <ErrorContentLocalizedX4EC />;
  }

  if (variant === 'theme-and-localized') {
    if (appId === 'cep') return <ErrorContentLocalizedX4C />;
    if (appId === 'x4ec') return <ErrorContentWithThemeX4EC />;
  }

  return <ErrorContentLocalizedX4C />;
};
